import Modal from "ui-kit/src/Modal/Modal";
import { ReactNode } from "react";
import { _ } from "i18n";

export interface BaseModalProps {
    isOpen: boolean;
    onClose: () => void;
    title?: string;
    size?: "sm" | "lg";
    children: ReactNode;
    className?: string;
}

export const BaseModal: React.FC<BaseModalProps> = ({
    isOpen,
    onClose,
    title,
    size = "lg",
    children,
    className
}) => {
    return (
        <Modal
            show={isOpen}
            onClose={onClose}
            title={title}
            size={size}
            className={className}
        >
            {children}
        </Modal>
    );
}; 